import Vue from 'vue'
import Router from 'vue-router'
import VueResource from 'vue-resource'
import routes from './routes'
import store from '@/store'

/**
 * @name 解决Vue-router报错 NavigationDuplicated
*/
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(Router)
Vue.use(VueResource)
Vue.http.options.emulateJSON = true

const router = new Router({
  mode: 'history',
  routes: [
    ...routes,
    {
      path: '*',
      redirect: { name: 'home' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  console.log('%c路由拦截', 'background-color: crimson;color: #fff;', to)
  const {meta: { lang }} = to
  store.dispatch('setLangue', lang)
  next()
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js